/** @format */

import * as actionTypes from './action-types';
/*
type State = {
  +userToken: string,
  // ...
};
*/

export const initialState = {
  helloMessageReceived: false,
  helloMessageTimeout: false,
  isAuthenticated: false,
  email: '',
  termsAndConditionsCompleted: false,
  AcceptedMarketing: false,
  AcceptedTerms: false,
  TermsAgreedAt: '',
  TermsVersion: '',
  isLoggingOut: false,
  demoMode: false,
  demoUnavailableVisible: false,
};

export const auth = (state = initialState, action) => {
  switch (action.type) {
    // case actionTypes.RESET_AUTH_STATE:
    //   return initialState;
    case actionTypes.SET_DEMO_MODE:
      return {
        ...state,
        demoMode: action.demoMode,
      };
    case actionTypes.DEMO_UNAVAILABLE_SHOWN:
      return {
        ...state,
        demoUnavailableVisible: true,
      };
    case actionTypes.DEMO_UNAVAILABLE_DISMISSED:
      return {
        ...state,
        demoUnavailableVisible: false,
      };
    case actionTypes.LOGOUT_COMPLETED:
      return {
        ...initialState,
        email: state.email,
      };
    case actionTypes.AMPLIFY_STATE_CHANGE:
      return {
        ...state,
        isAuthenticated: action.isAuthenticated,
        email: action.email,
      };
    case actionTypes.HOMES_MESSAGE_RECEIVED:
    case actionTypes.WEBSOCKET_HELLO_MESSAGE_RECEIVED:
      return {
        ...state,
        helloMessageReceived: true,
        helloMessageTimeout: false,
      };
    case actionTypes.WEBSOCKET_HELLO_MESSAGE_TIMEOUT:
      if (!state.helloMessageReceived) {
        return {
          ...state,
          helloMessageTimeout: true,
        };
      }

      return state;
    case actionTypes.WEBSOCKET_HELLO_MESSAGE_TIMEOUT_CLEARED:
      return {
        ...state,
        helloMessageTimeout: false,
      };
    case actionTypes.SIGNUP:
      return {
        ...state,
        email: action.email,
        termsAndConditionsCompleted: true,
        AcceptedMarketing: action.AcceptedMarketing,
        TermsAgreedAt: action.TermsAgreedAt,
        TermsVersion: action.TermsVersion,
      };
    case actionTypes.ACCEPT_TERMS_SET:
      return {
        ...state,
        AcceptedTerms: action.acceptTerms,
        TermsAgreedAt: action.acceptedTermsTime,
        TermsVersion: action.termsVersion,
      };
    case actionTypes.ACCEPT_TERMS_CLEARED:
      return {
        ...state,
        AcceptedTerms: false,
        TermsAgreedAt: '',
        TermsVersion: '',
      };
    case actionTypes.ACCEPT_MARKETING_SET:
      return {
        ...state,
        AcceptedMarketing: action.acceptMarketing,
      };
    case actionTypes.LOGOUT_STARTED:
      return {
        ...state,
        isLoggingOut: true,
      };
    case actionTypes.LOGOUT_FAILED:
      return {
        ...state,
        isLoggingOut: false,
      };
    default:
      return state;
  }
};

export const authSensitive = (state = { password: '' }, action) => {
  switch (action.type) {
    case actionTypes.SIGNUP_SENSITIVE:
      return {
        ...state,
        password: action.password,
      };
    default:
      return state;
  }
};

export const deviceRegistrationInitialState = {
  registrationAttempts: 0,
  serialNumber: '',
  pin: '',
  deviceRegistrationSucceeded: false,
  deviceRegistrationInProgress: false,
  deviceRegistrationError: '',
  errorTitle: '',
  deviceRegistrationInputValid: false,
};

const validateSerial = serialNumber => {
  return serialNumber.length > 4;
};

export const deviceRegistration = (
  state = deviceRegistrationInitialState,
  action,
) => {
  switch (action.type) {
    case actionTypes.DEVICE_REGISTRATION_ATTEMPTS_RESET:
      return {
        ...state,
        registrationAttempts:
          deviceRegistrationInitialState.registrationAttempts,
      };
    case actionTypes.DEVICE_REGISTRATION_SERIALNUMBER_SET:
      return {
        ...state,
        serialNumber: action.serialNumber,
        deviceRegistrationInputValid: validateSerial(action.serialNumber),
      };
    case actionTypes.LOGOUT_COMPLETED:
      return deviceRegistrationInitialState;
    default:
      return state;
  }
};

export const gatewayManagementInitialState = {
  gateways: [],
  listAllDevicesInProgress: false,
  listAllDevicesSucceeded: false,
  listAllDevicesErrorMessage: '',
};

export const gatewayManagement = (
  state = gatewayManagementInitialState,
  action,
) => {
  switch (action.type) {
    case actionTypes.LIST_ALL_DEVICES_STARTED:
      return {
        ...state,
        listAllDevicesInProgress: true,
        gateways: [],
      };
    case actionTypes.LIST_ALL_DEVICES_FAILED:
      return {
        ...state,
        listAllDevicesSucceeded: false,
        listAllDevicesInProgress: false,
        listAllDevicesErrorMessage: action.message,
      };
    case actionTypes.LIST_ALL_DEVICES_SUCCEEDED:
      return {
        ...state,
        listAllDevicesSucceeded: true,
        listAllDevicesInProgress: false,
        gateways: action.gateways,
      };
    default:
      return state;
  }
};

// combined Root reducer now lives in store
